// Generated from src/img/svg/switcher_topo.svg

export const SwitcherTopo = (props) => {
  return (
    <svg
      id="switcher_topo_svg__Ebene_1"
      version="1.1"
      viewBox="0 0 50 50"
      x="0"
      xmlSpace="preserve"
      y="0"
      {...props}
    >
      <style>{".switcher_topo_svg__st1{fill:#353535}"}</style>
      <path
        d="m44.8 21.8-5.3 3.3H10.6l-5.4-3.3 1.1-3.2L25 8.6l19.8 11.1z"
        style={{ fill: "#cecece" }}
      />
      <path
        className="switcher_topo_svg__st1"
        d="M25 19.7c5.3 0 10.4 1.9 14.5 5.4L25 34l-14.4-8.9c4-3.5 9.1-5.4 14.4-5.4"
      />
      <path
        className="switcher_topo_svg__st1"
        d="m48.5 19.5-3.8 2.3C33.8 11 16.2 11 5.2 21.8l-3.8-2.3L25 5zM48.5 30.5 25 45 1.5 30.5l4.8-2.9L25 39.1l18.7-11.5z"
      />
      <path d="M0 0h50v50H0z" style={{ fill: "none" }} />
    </svg>
  );
};
